export default __webpack_public_path__ + "static/w7-52ef651dabf81e0f50b37ae5133c7c0d.webp";